/* eslint-disable no-console */
const formatLogData = (level, data: any = {}) => {
  let error;
  if (
    data !== null &&
    Object.prototype.hasOwnProperty.call(data, 'error') &&
    data.error instanceof Error &&
    !Object.prototype.hasOwnProperty.call(data, 'errorAsString')
  ) {
    error = data.error.toString();
  }

  return {
    ...data,
    error,
    level,
    timestamp: new Date().toISOString(),
    name: 'oat-frontend',
  };
};

const createLogger = (): any => {
  const levelMap = {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10,
  };

  const createMethod =
    (level) =>
    (data = {}) => {
      const formatted = formatLogData(level, data);
      console.log(formatted);
    };

  return Object.keys(levelMap).reduce((accumulator, name) => {
    const formatterFunction = createMethod(levelMap[name]);
    return {
      ...accumulator,
      [name]: formatterFunction,
    };
  }, {});
};

export default createLogger();
